import { useEffect } from "react";
import ReactGA from "react-ga";
export const useGA = () =>
    useEffect(() => {
        window.scrollTo(0, 0);
        ReactGA.initialize("UA-3173806-2");
        ReactGA.ga("set", "anonymizeIp", true);
        ReactGA.pageview(window.location.pathname + window.location.search);
    }, []);
